import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import Info from './Info';


function Visor() {
  return (
    <>
    <Banner titleSection={'VISUALIZADOR'} linkName={'Inicio'} nameSection={'Visualizador'} />
    <Spacer/>
    <Info/>
    <Spacer/>
    </>
  )
}

export default Visor